var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4617 2.39997H16.0617C16.3705 2.39997 16.6521 2.57837 16.7849 2.85758C16.9177 3.13678 16.8769 3.46718 16.6809 3.70718L9.89531 12L16.6809 20.2936C16.8769 20.5328 16.9169 20.8632 16.7849 21.1432C16.6529 21.4232 16.3705 21.6 16.0617 21.6H14.4617C14.2217 21.6 13.9945 21.492 13.8425 21.3064L6.64251 12.5064C6.40171 12.2112 6.40171 11.788 6.64251 11.4928L13.8425 2.69277C13.9945 2.50797 14.2217 2.39997 14.4617 2.39997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.db1f95f9bd077516e3a0740e1d8e3218.svg";
export { ForwardRef as ReactComponent };